import { BookmarkHelpers } from "../helpers/bookmark-helpers";

/**
 * Keeps the portal nav's bookmark count bubble (".portal-nav-bookmarks .bookmark-count") in sync.
 *
 * The initial count always comes from a fresh AJAX call (GET /api/bookmarks via
 * BookmarkHelpers.fetchBookmarks) rather than a server-rendered/cached value, so it can't go stale.
 * After that it stays current by re-rendering from BookmarkHelpers' in-memory cache whenever a
 * "bookmarks:updated" event fires (dispatched by BookmarkHelpers.addToCache/removeFromCache, which
 * run right after a successful add/remove API call anywhere on the page).
 */
export class BookmarkNavCount {
	private readonly badge: HTMLElement | null;

	constructor() {
		this.badge = document.querySelector('.portal-nav-bookmarks .bookmark-count');
		if (!this.badge) return;

		this.refresh();
		document.addEventListener('bookmarks:updated', () => this.render(BookmarkHelpers.getCount()));
	}

	private refresh(): void {
		BookmarkHelpers.fetchBookmarks().then(bookmarks => this.render(bookmarks.length));
	}

	private render(count: number): void {
		if (!this.badge) return;
		this.badge.textContent = String(count);
		this.badge.classList.toggle('d-none', count === 0);
	}
}
